import React, { useState, useEffect, useCallback } from "react";
import "./Appstrip.css";
import { useLocation } from "react-router-dom";

function Appstrip() {
  
    const HEADER_ID = "navbar";
    const HEADING_ID = "stripcount-margin";
    const MAX_COUNT = 3;

    const [visible, setVisible] = useState(false);
    const location = useLocation();

    /* ================= UTILS ================= */

    const isMobile = () => window.innerWidth <= 768;

    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const d = new Date();
            d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + d.toUTCString();
        }
        document.cookie = `${name}=${value}${expires}; path=/`;
    };

    const getCookie = (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        for (let c of ca) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length);
            }
        }
        return null;
    };

    /* ================= DEVICE DETECTION ================= */

    const getDeviceType = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(ua)) return "android";
        if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
        return "other";
    };

    const getRedirectLink = () => {
        const device = getDeviceType();
        if (device === "android") return "https://play.google.com/store/apps/details?id=com.firstcry.playbees.learn.grow.kids.preschool.toddler.numbers.abc.rhymes.games.stories.books&hl=en";
        if (device === "ios") return "https://apps.apple.com/in/app/playbees-kids-learning-games/id1529402533";
        return "";
    };

    /* ================= HEADER CLASS ================= */

    const addHeaderClass = () => {
        const header = document.getElementById(HEADER_ID);
        header?.classList.add("stripcount");

        const heading = document.getElementById(HEADING_ID);
        heading?.classList.add("stripcount-heading");
    };

    const removeHeaderClass = () => {
        const header = document.getElementById(HEADER_ID);
        header?.classList.remove("stripcount");

        const heading = document.getElementById(HEADING_ID);
        heading?.classList.remove("stripcount-heading");
    };

    /* ================= MAIN LOGIC ================= */

    const syncHeaderWithCookie = useCallback(() => {
        if (!isMobile()) return;

        const count = parseInt(getCookie("stripcount") || 0, 10);

        if (count >= MAX_COUNT) {
            removeHeaderClass();
        } else {
            addHeaderClass();
        }
    }, []);

    const initStrip = useCallback(() => {
        if (!isMobile()) return;

        const count = parseInt(getCookie("stripcount") || 0, 10);
        setVisible(count < MAX_COUNT);
    }, []);


    /* ================= EVENTS ================= */

    const closeStrip = (e) => {
        e.stopPropagation();

        const count = parseInt(getCookie("stripcount") || 0, 10);
        setCookie("stripcount", count + 1, 3);

        setVisible(false);
        removeHeaderClass();
    };

    const openLink = () => {
        const url = getRedirectLink();
        if (url) window.location.href = url;
    };

    /* ================= LIFECYCLE ================= */

    useEffect(() => {
        syncHeaderWithCookie();
        initStrip();
    }, [location.pathname, syncHeaderWithCookie, initStrip]);


    /* ================= RENDER ================= */

    if (!visible) return null;



    return (
        <div id="Inhouseappstrip" className="Inhousecontainer" onClick={openLink}>
            <div className="mid-container-wrapper">
                <div className="mid-container">
                    <div className="cross-icon" onClick={(e) => {
                            e.stopPropagation();
                            closeStrip(e);
                        }}>
                        <img src="https://cdn.cdnparenting.com/brainbees/community/playbees/cross-Icon.svg" alt="Close" />
                    </div>

                    <div>
                        <img src="images/appstrip/logo.png" alt="App logo" className="strip-logo" />
                    </div>

                    <div>
                        <p id="msg">1000+ Learning Games & Activities for Kids!</p>
                        <div className="smllstar"><div className="activer"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="staricon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="staricon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="staricon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="staricon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="staricon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"></path></svg></div></div>
                    </div>

                    <div className="last-container">
                        {/* <a href="#" id="redirection"> */}
                            <button id="cta">Install app</button>
                        {/* </a> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Appstrip;
